export default __webpack_public_path__ + "static/media/salesforce.134d1205.svg";